import React, { useEffect, useState } from "react";
import { Modal, Button, Form, Input, Dropdown, Select, Row, Col } from "antd";
import log from "cslog";
import { useCreateItemMutation, useSingleItem } from "../../_actions/app/items";
import LoadingBox from "../../common/LoadingBox";
import { nanoid } from "nanoid";
import { useCreateItem } from "../../_actions/mutations/items";
import {
    usePublishTemplate,
    useUpdateTemplate,
} from "../../_actions/app/templates";
import RelationFieldStanard from "../../qforms/standard_elements/RelationFieldStandard";
import { useDeleteItemMutation } from "../../actions/app/items";

function PublishTemplateModal({
    trigger,
    data,
    onSuccess = () => {},
    template_id,
    default_values = {},
}) {
    const [open, setOpen] = React.useState(false);
    const [loading, setLoading] = React.useState(false);
    const [form] = Form.useForm();
    const branding_type_value = Form.useWatch("branding_type", form);

    const {
        data: dataCreation,
        isSuccess: successCreation,
        isLoading: loadingCreation,
        refetch: refetchCreation,
    } = useSingleItem(
        "qp_creation",
        `/${data.id}?fields=*,used_schemas.*`,
        open,
    );

    const mutationPublish = usePublishTemplate(
        () => {
            log.success("Template Published");
            // setLoading(false);
            onSuccess();
            setOpen(false);
        },
        () => {
            log.error("Template Publish Failed");
        },
        () => {
            log.info("Template publish completed.");
            // setLoading(false);
        },
    );
    const mutationUpdateTemplate = useUpdateTemplate(
        () => {
            log.success("Template updated");
            onSuccess();
            setOpen(false);
        },
        () => {
            log.error("Template update failed");
        },
        () => {
            log.info("Template update completed.");
            // if the hook toggles its own loading, it will settle here
        },
    );

    const mutationdelete = useDeleteItemMutation(
        () => {
            log.success("Preset deleted");
            // alert("Deleted");
            refetchCreation();
        },
        () => {
            log.error("Failed to delete preset");
        },
    );

    const mutationCreateJunction = useCreateItemMutation(
        () => {
            log.success("Preset(s) added");
            refetchCreation();

            form.setFieldsValue({ add_used_schemas: [] });
        },
        () => {
            log.error("Failed to add preset(s)");
        },
    );
    const handleDeleteSchema = (schemaJunctionId) => {
        // Filter out the schema to be deleted
        log.d(schemaJunctionId, "delete preset");
        mutationdelete.mutate({
            collection: "qp_creation_qdb_creation_schema",
            id: schemaJunctionId,
        });
    };

    const handleAddSchemas = () => {
        const ids = form.getFieldValue("add_used_schemas") || [];
        if (!ids.length || !dataCreation?.id) return;

        // Create junction rows for each selected schema
        ids.forEach((schemaId) => {
            mutationCreateJunction.mutate({
                collection: "qp_creation_qdb_creation_schema",
                data: {
                    qp_creation_id: dataCreation.id,
                    qdb_creation_schema_id: schemaId,
                },
            });
        });
    };
    log.d(data, "PTM data");
    log.d(dataCreation, "dataCreation");

    useEffect(() => {
        // setLoading(false);
        if (!branding_type_value) {
            const branding_type = localStorage.getItem(
                "template_publish_branding_type",
            );
            if (branding_type) {
                form.setFieldsValue({
                    branding_type,
                });
            }
        }
    }, [open]);

    useEffect(() => {
        if (branding_type_value) {
            localStorage.setItem(
                "template_publish_branding_type",
                branding_type_value,
            );
        }
    }, [branding_type_value]);

    const is_festival =
        data?.used_schemas?.findIndex(
            (item) =>
                item?.qdb_creation_schema_id?.id ===
                "0e0c5b74-e8d5-4237-be1e-8e4ae3dded98",
        ) !== -1;

    const is_no_preset = data?.used_schemas?.length === 0;

    useEffect(() => {
        form.setFieldsValue({
            branding_type: "org_detailed",
            title: data?.title,
            ...default_values,
        });
    }, [data]);

    const publishNow = () => {
        // setLoading(true);

        console.clear();
        log.d(dataCreation, "dataCreation");

        const used_schemas = dataCreation.used_schemas.map((item) => ({
            qdb_creation_schema_id: item?.qdb_creation_schema_id,
        }));

        const out_data = {
            organization: dataCreation.organization,
            title: `Copy_${dataCreation.title}`,
            info: dataCreation.info,
            layout: dataCreation.layout,
            gconfig: dataCreation.gconfig,
            data: dataCreation.data,
            others: dataCreation.others,
            seo: dataCreation.seo,
            viewers: dataCreation.viewers,
            extensions: dataCreation.extensions,
            urlsettings: dataCreation.urlsettings,
            permissions: dataCreation.permissions,
            slug: `${dataCreation?.info.type}_${nanoid(7)}`,
            type: dataCreation.type,
            creation_type: dataCreation.creation_type,
            theme: dataCreation.theme,
            is_themeable: dataCreation.is_themeable,
        };

        log.d(out_data, "out_data");

        const form_values = form.getFieldsValue();
        log.d(form_values, "form values");

        let new_used_schemas = [];
        if (dataCreation?.used_schemas?.length === 0) {
            new_used_schemas = form_values.used_schemas?.map((item) => ({
                qdb_creation_schema_id: item,
            }));
        }

        const primary_tag = form_values.primary_tag;

        const out = {
            used_schemas: used_schemas,
            inputs: dataCreation.inputs,
            layout: dataCreation.info?.layout,
            typebase: dataCreation.info?.typebase,
            type: dataCreation.type,
            urlsettings: dataCreation.urlsettings,
            creation: dataCreation.id,
            types: [{ qdb_creation_type_id: dataCreation.creation_type }],

            data: out_data,

            visibility: "public",
            tags: [],
            theme: dataCreation.theme,
            is_themeable: dataCreation.is_themeable,

            // title: dataCreation.title,
            // industries: [],
            // branding_type: "none",
            ...form_values,
            ...(new_used_schemas?.length > 0
                ? { used_schemas: new_used_schemas }
                : {}),
            ...(form_values.primary_tag
                ? { primary_tags: [{ qdb_tag_id: primary_tag }] }
                : {}),
        };

        log.d(out, "Final OUT");

        if (template_id) {
            log.d(out, `Updating template ${template_id}`);
            mutationUpdateTemplate.mutate({
                id: template_id,
                data: out,
            });
        } else {
            mutationPublish.mutate(out);
        }
    };

    return (
        <>
            <div onClick={() => setOpen(true)}>{trigger}</div>
            <Modal
                open={open}
                onOk={() => setOpen(false)}
                onCancel={() => setOpen(false)}
                width="500px"
                title="Publish Template"
                footer={[
                    <Button key="back" onClick={() => setOpen(false)}>
                        Cancel
                    </Button>,
                    <Button
                        key="action"
                        type="primary"
                        disabled={!successCreation}
                        onClick={publishNow}
                        // loading={loading}
                        loading={
                            mutationPublish.isLoading ||
                            mutationUpdateTemplate.isLoading
                        }
                    >
                        {template_id ? "Update Template" : "Publish Now"}
                    </Button>,
                ]}
            >
                {loadingCreation && <LoadingBox text="Loading Creation" />}
                {successCreation && (
                    <div>
                        <Form form={form} layout="vertical">
                            <Form.Item label="Title" name="title">
                                <Input />
                            </Form.Item>
                            {/* <p>Branding is {form.getFieldValue("branding_type")}</p> */}

                            <Row gutter={[10, 10]}>
                                <Col xs={24} sm={24}>
                                    <Form.Item
                                        label="Branding Type"
                                        name="branding_type"
                                    >
                                        <div
                                            style={{
                                                display: "flex",
                                                flexDirection: "row",
                                                alignItems: "center",
                                                flexWrap: "wrap",
                                                width: "100%",
                                                gap: "5px",
                                            }}
                                        >
                                            {[
                                                { key: "none", label: "None" },
                                                {
                                                    key: "org_minimal",
                                                    label: "Organization Minimal",
                                                },
                                                {
                                                    key: "org_detailed",
                                                    label: "Organization Detailed",
                                                },
                                                {
                                                    key: "personal_minimal",
                                                    label: "Personal Minimal",
                                                },
                                                {
                                                    key: "personal_detailed",
                                                    label: "Personal Detailed",
                                                },
                                            ].map((item) => (
                                                <div
                                                    key={item.key}
                                                    onClick={() => {
                                                        form.setFieldsValue({
                                                            branding_type:
                                                                item.key,
                                                        });
                                                    }}
                                                    style={{
                                                        cursor: "pointer",
                                                        padding: "5px 10px",
                                                        border: "1px solid #ccc",
                                                        borderRadius: "5px",
                                                        backgroundColor:
                                                            form.getFieldValue(
                                                                "branding_type",
                                                            ) === item.key
                                                                ? "lightblue"
                                                                : "white",
                                                    }}
                                                >
                                                    {item.label}
                                                </div>
                                            ))}
                                        </div>
                                        {/* <Select
                                        options={[
                                            { label: "None", value: "none" },
                                            { label: "Organization Minimal", value: "org_minimal" },
                                            { label: "Organization Detailed", value: "org_detailed" },
                                            { label: "Personal Minimal", value: "personal_minimal" },
                                            { label: "Personal Detailed", value: "personal_detailed" },
                                        ]}
                                    /> */}
                                    </Form.Item>
                                </Col>
                                {/* <Col xs={24} sm={12}>
                                <Form.Item label="Industries" name="industries">
                                    <RelationFieldStanard
                                        field={{
                                            foreign_key_table: "qdb_industry",
                                            // foreign_key_column: "id",
                                            junction_field: "qdb_industry_id",
                                            many_table_pk: "id",
                                            template: "{{name}}",
                                            type: "relationO2M",
                                        }}
                                        // fieldString="&limit=-1&filter[irole][_eq]=designer"

                                        many={true}
                                        style={{
                                            width: "100%"
                                        }}
                                        additional_options={[]}
                                    />
                                </Form.Item>
                            </Col> */}
                            </Row>

                            {is_festival && (
                                <Form.Item
                                    label="Primary Tag"
                                    name="primary_tag"
                                >
                                    <RelationFieldStanard
                                        field={{
                                            type: "relationM2O",
                                            foreign_key_table: "qdb_tag",
                                            foreign_key_column: "id",
                                            template: "{{name}}",
                                        }}
                                        style={
                                            {
                                                // width: "300px"
                                            }
                                        }
                                        fieldString="limit=-1&filter[type][_eq]=primary"
                                        many={false}
                                    />
                                </Form.Item>
                            )}

                            {/* Existing presets with delete option */}
                            {dataCreation?.used_schemas?.length > 0 && (
                                <div style={{ marginBottom: 12 }}>
                                    <div style={{ marginBottom: 6 }}>
                                        Presets:
                                    </div>
                                    <div
                                        style={{
                                            display: "flex",
                                            gap: 8,
                                            flexWrap: "wrap",
                                        }}
                                    >
                                        {data.used_schemas.map((rel) => (
                                            <div
                                                key={rel.id}
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: 6,
                                                    border: "1px solid #e0e0e0",
                                                    borderRadius: 6,
                                                    padding: "4px 8px",
                                                    background: "#fafafa",
                                                }}
                                            >
                                                <span>
                                                    {rel?.qdb_creation_schema_id
                                                        ?.name || "Untitled"}
                                                </span>
                                                <Button
                                                    size="small"
                                                    danger
                                                    onClick={() =>
                                                        handleDeleteSchema(
                                                            rel.id,
                                                        )
                                                    }
                                                    loading={
                                                        mutationdelete.isLoading
                                                    }
                                                >
                                                    Delete
                                                </Button>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}
                            {/* Always allow adding more presets */}
                            <Form.Item
                                label="Add Preset(s)"
                                name="add_used_schemas"
                            >
                                <RelationFieldStanard
                                    field={{
                                        foreign_key_table:
                                            "qdb_creation_schema",
                                        foreign_key_column: "id",
                                        junction_field:
                                            "qdb_creation_schema_id",
                                        many_table_pk: "id",
                                        template:
                                            "{{qdb_creation_schema_id.name}}",
                                        type: "relationM2M",
                                    }}
                                    fieldString="limit=-1&sort=name&filter[block_id][_eq]=heading_preset"
                                    many={true}
                                    style={{ width: "100%" }}
                                    additional_options={[]}
                                />
                            </Form.Item>
                            <div style={{ marginBottom: 16 }}>
                                <Button
                                    type="dashed"
                                    onClick={handleAddSchemas}
                                    loading={mutationCreateJunction.isLoading}
                                >
                                    Add Selected
                                </Button>
                            </div>

                            {is_no_preset && (
                                <Form.Item
                                    label="Add Blank Preset"
                                    name="used_schemas"
                                >
                                    <RelationFieldStanard
                                        // key={render_key}
                                        field={{
                                            foreign_key_table:
                                                "qdb_creation_schema",
                                            foreign_key_column: "id",
                                            junction_field:
                                                "qdb_creation_schema_id",
                                            many_table_pk: "id",
                                            template:
                                                "{{qdb_creation_schema_id.name}}",
                                            type: "relationM2M",
                                        }}
                                        fieldString="limit=-1&filter[is_blank][_eq]=true"
                                        many={true}
                                        style={{
                                            width: "100%",
                                        }}
                                        additional_options={[]}
                                    />
                                </Form.Item>
                            )}
                        </Form>
                    </div>
                )}
            </Modal>
        </>
    );
}

export default PublishTemplateModal;
